import RepaymentInfo from './RepaymentInfo.vue';

export default RepaymentInfo;
